import { coarsePointerNoBackdropBlur } from 'features/knowledgeDocumentViewer/components/viewer/shared/coarsePointerNoBackdropBlur'
import styled from 'styled-components'

export const MinimapContainer = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  z-index: 10;
  background-color: color-mix(
    in oklch,
    ${(props) => props.theme.forecast.pageBackground1},
    transparent 20%
  );
  backdrop-filter: blur(2rem);
  -webkit-backdrop-filter: blur(2rem);
  ${coarsePointerNoBackdropBlur}
  border-radius: 0.25rem;
  border: 1px solid ${(props) => props.theme.forecast.border};
  overflow: hidden;
  user-select: none;
  touch-action: none;
`

export const MinimapImageWrapper = styled.div<{
  $width: number
  $height: number
}>`
  position: relative;
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height}px;
  overflow: hidden;
`

export const MinimapImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
`

export const MinimapMultipageContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`

export const ViewportIndicator = styled.div.attrs<{
  $left: number
  $top: number
  $width: number
  $height: number
}>((props) => ({
  style: {
    left: `${props.$left}px`,
    top: `${props.$top}px`,
    width: `${props.$width}px`,
    height: `${props.$height}px`,
  },
}))<{
  $left: number
  $top: number
  $width: number
  $height: number
}>`
  position: absolute;
  border: 2px solid ${(props) => props.theme.forecast.highlight};
  background-color: color-mix(
    in oklch,
    ${(props) => props.theme.forecast.highlight},
    transparent 80%
  );
  cursor: grab;
  pointer-events: auto;
  touch-action: none;

  &:active {
    cursor: grabbing;
  }
`
